import $ from "jquery";

export default class MiniCart {
    constructor() {
        this.cart = $('#smallCart')
        this.openCart = $('.js-openSmallCart')
        this.closeCart = $('.js-close-minicart')

        this.cartContent = $('.js-miniCartContent')

        this.addToCartButton = $('.js-add-to-cart')

        this.removeItemFromCartButton = $('.js-removeFromCart')

        this.event()
    }

    event() {
        this.openCart.on('click', (e) => {
            e.preventDefault()
            this.openMiniCart()
        })
        this.closeCart.on('click', (e) => {
            e.preventDefault()
            this.closeMiniCart()
        })

        this.addToCartEvent(this.addToCartButton)
        this.removeItemFromCart()

        this.changeQty()

    }

    openMiniCart() {
        $('body').addClass('js-smallCartOpen')
        this.cart.addClass('small-cart--open')
    }

    closeMiniCart() {
        $('body').removeClass('js-smallCartOpen')
        this.cart.removeClass('small-cart--open')
    }

    removeItemFromCart() {
        this.cartContent.on('click', '.js-removeFromCart', (e) => {
            e.preventDefault()
            const key = $(e.target).data('key')
            if (key) {
                fetch(window.global.ajax_url + "?action=removeFromCart", {
                    method: "POST", //* GET, POST, PUT, DELETE, etc.
                    mode: "cors", // no-cors, *cors, same-origin
                    cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
                    credentials: "same-origin", // include, *same-origin, omit
                    headers: {
                        // "Content-Type": "application/json",
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    redirect: "follow", // manual, *follow, error
                    referrerPolicy: "no-referrer", // no-referrer, *client
                    body: new URLSearchParams({
                        security: window.global.security,
                        key: key,
                    }),
                })
                    .then((resp) => resp.json())
                    .then((data) => {
                        if (data.success === false) {
                            console.log(data)
                        }

                        if (data.success) {
                            if (data.data.cart_content) {
                                this.cartContent.empty().append(data.data.cart_content)
                            }
                            if (data.data.cart_count) {
                                this.updateCartCount(data.data.cart_count)
                            }
                        }
                    })
            }
        })
    }

    changeQty() {
        let prevValue = 0
        this.cartContent.on('focusin', '.custom-number-input', (e) => {
            prevValue = $(e.target).siblings('.input').val()
        })
        this.cartContent.on('change', '.custom-number-input > .input', (e) => {
            const parent = $(e.target).parents('.small-cart-item')
            parent.addClass('small-cart-item--loader')
            const key = parent.data('key')
            if (key) {
                fetch(window.global.ajax_url + "?action=chaneQty", {
                    method: "POST", //* GET, POST, PUT, DELETE, etc.
                    mode: "cors", // no-cors, *cors, same-origin
                    cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
                    credentials: "same-origin", // include, *same-origin, omit
                    headers: {
                        // "Content-Type": "application/json",
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    redirect: "follow", // manual, *follow, error
                    referrerPolicy: "no-referrer", // no-referrer, *client
                    body: new URLSearchParams({
                        security: window.global.security,
                        key: key,
                        quantity: e.target.value,
                    }),
                })
                    .then((resp) => resp.json())
                    .then((data) => {
                        if (data.success === false) {
                            $(e.target).val(prevValue)
                        }
                        if (data.success) {
                            if (data.data.cart_content) {
                                this.cartContent.empty().append(data.data.cart_content)
                            }
                            if (data.data.cart_count) {
                                this.updateCartCount(data.data.cart_count)
                            }
                        }
                    })
                    .finally(() => {
                        parent.removeClass('small-cart-item--loader')
                    }).catch(() => {
                    $(e.target).val(prevValue)
                })
            }
        })
    }

    addToCartEvent(button) {
        if (button) {
            button.on('click', (e) => {
                e.preventDefault()
                const productId = e.target.value
                if (productId) this.addToCart(productId, false)
            })
        }
    }

    addToCart(productId, isCartPage) {
        fetch(window.global.ajax_url + "?action=addProductToCart", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                id: productId,
                qty: 1,
                isCartPage: isCartPage,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success === false) {

                }

                if (data.success) {
                    if (data.data.cart_content) {
                        this.cartContent.empty().append(data.data.cart_content)
                        this.openMiniCart()
                    }
                    if (data.data.cart_count) {
                        this.updateCartCount(data.data.cart_count)
                    }
                }
            })
    }

    updateCartCount(cartCount) {
        $('.js-cartCount').empty().append(cartCount)
    }
}